module.exports = __webpack_public_path__ + "static/media/pass_success.02f6da9e.svg";